<template lang="html">
    <div class="buyInfo">
        <div class="leftInfo" @click="onShowSelectDialog">
            <p class="total">
                <span class="text">总价：</span>
                <span class="price"><span class="flag">￥</span>{{ totalPrices }}</span>
            </p>
            <p class="detail">
                包含：{{ goodsNum }}件商品，{{ serviceNum }}项服务
                <van-icon v-if="!isShow" name="arrow-up" color="#666666" class="arrow"/>
                <van-icon v-else name="arrow-down" color="#666666" class="arrow"/>
            </p>
        </div>
        <a href="javascript:void(0)" @click="onBuy" :class="{btn:true, disabled: goodsNum === 0 && serviceNum === 0 }">立即购买</a>
    </div>
</template>
<script>
import eventBus, { ADVICE_SHOW_POP } from 'utils/eventBus.js'
export default {
    name: 'buyInfo',
    props: {
        /* 商品数量 */
        goodsNum : {
            type: Number,
            default () {
                return 0
            }
        },
        /* 服务数量 */
        serviceNum : {
            type: Number,
            default () {
                return 0
            }
        },
        /* 总价 */
        totalPrices : {
            type: Number,
            default () {
                return 0
            }
        },
    },
    components: {
    },
    data () {
        return {
            isShow: false
        }
    },
    created () {
        eventBus.$on(ADVICE_SHOW_POP, (bool) => {
            this.isShow = bool
            console.log(bool)
        })
    },
    methods:{
        /**
         * 立即购买
         */
        onBuy () {
            /* 服务选择数量和商品选择数量为空不可点击 */
            if (this.goodsNum !== 0 || this.serviceNum !== 0) {
                this.$emit('onBuy')
            }
        },
        /**
         * 显示选择的商品服务款
         */
        onShowSelectDialog () {
            /* 服务选择数量和商品选择数量为空不可点击 */
            if (this.goodsNum !== 0 || this.serviceNum !== 0) {
                this.$emit('onShowSelectDialog')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.buyInfo
    position fixed
    bottom 0
    left 0
    width 100%
    z-index 3000
    height 100px
    background #fff
    display flex
    align-items center
    .leftInfo
        flex 1
        text-align right
        padding-right 18px
        .total
            .text
                font-size 22px
                line-height 22px
                color #666666
            .price
                color #fc2d2d
                font-size 34px
                line-height 34px
                .flag
                    color #fc2d2d
                    font-size 24px
        .detail
            color #666666
            font-size 22px
            line-height 30px
            .arrow
                margin 0 14px
    .btn
        width 300px
        height 98px
        background-color #fc2d2d
        color #ffffff
        font-size 34px
        text-align center
        line-height 98px
    .disabled
        background #999999
        color #ffffff
</style>
